module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/keys.js
// module id = 60
// module chunks = 0